import {
    ApplicationTypes, DebtTypes, EmploymentBases, EmploymentTypes,
    MortgageTypes, PersonalAccommodationSituations,
    PersonalMaritalStatuses
} from "../../../../../models";
import dayjs from "dayjs";
import {capitaliseFirst, convertHtmlToPlainText, toCurrencyString, toEuroString} from "../../../string-functions";
import countries from "../../../countries.json";
import {legacyIncome} from "../../../../../app/components/client/application-stages/_common/lender-tests/useXlsTests";
import {camelToWords} from "../../../functions";
import React from "react";
import {
    accountSummaryToReviewOfAccounts,
    coverNoteStrings,
    getAppStrings, getTestedFigures, getTestedOutput, grossBasicAnnualSalary,
    grossBasicMonthlySalary
} from "../../../../../config-files/mortgage/documents/SussdCoverNoteV2";

export default function (mortgage, config) {
    const strings = coverNoteStrings(mortgage)
    const figures = getTestedFigures(mortgage)
    const output = getTestedOutput(mortgage)
    const accountSummary = mortgage.accountSummary()
    const reviewOfAccounts =    accountSummaryToReviewOfAccounts(accountSummary)


    const page1 = () => {
        let map = {}
        let ask = []

        // home loan description
        ask.push({
            label: 'Home Loan Description',
            name: 'homeLoanDescription',
            type: 'TEXT',
            group: 'Page 1 - Mortgage Details'
        })
        let app1DOB = dayjs(mortgage.applicant1.personal.dateOfBirth, "YYYY-MM-DD")
        let app1Age = dayjs().diff(app1DOB, 'years')
        let finalString = `${mortgage.applicant1.fullName} (${app1Age})`
        if (mortgage.twoApplicants) {
            let app2DOB = dayjs(mortgage.applicant2.personal.dateOfBirth, "YYYY-MM-DD")
            let app2Age = dayjs().diff(app2DOB, 'years')
            finalString += `& ${mortgage.applicant2.fullName} (${app2Age})`
        }

        map['Dear Underwriter, Home loan application:'] = config.hasOwnProperty('homeLoanDescription') ? {string: config.homeLoanDescription} : {string: finalString}

        // first time buyer
        map['FTB'] = {check: mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.applicationType === ApplicationTypes.FIRSTTIME}

        // second time
        map['STB'] = {check: mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.applicationType !== ApplicationTypes.FIRSTTIME}

        // straight switcher
        map['Straight Switcher'] = {check: mortgage.mortgageType === MortgageTypes.REFINANCE}

        // switcher with equity release
        map['Switch with Equity Release'] = {check: false}

        map['Top Up'] = {check: false}


        // personal circumstances
        ask.push({
            label: 'Personal Circumstances',
            name: 'personalCircumstances',
            type: 'TEXT',
            group: 'Page 1 - Marital Status'
        })

        function getPersonalCircumstances(){
            if (mortgage.twoApplicants){
                return strings.app1.nameAndNationality + ' & ' + strings.app2.nameAndNationality
            }
            return strings.app1.nameAndNationality
            // if (mortgage.twoApplicants){
            //
            //     if ([PersonalMaritalStatuses.MARRIED, PersonalMaritalStatuses.REMARRIED].includes(mortgage.applicant1.personal.maritalStatus) && [PersonalMaritalStatuses.MARRIED, PersonalMaritalStatuses.REMARRIED].includes(mortgage.applicant2.personal.maritalStatus)) {
            //        return 'Married'
            //     }
            //     if (mortgage.requirement.cohabiting){
            //         return 'Cohabiting'
            //     }
            // }
            // else{
            //     if ([PersonalMaritalStatuses.MARRIED, PersonalMaritalStatuses.REMARRIED].includes(mortgage.applicant1.personal.maritalStatus)) {
            //         return 'Married'
            //     }
            // }
            // return 'Single'
        }

        map['Personal Circumstance']  = config.hasOwnProperty('personalCircumstances') ? {string: config.personalCircumstances} : {string: getPersonalCircumstances()}

        // marital status - married
        ask.push({
            label: 'Married',
            name: 'maritalStatusMarried',
            type: 'CHECK',
            group: 'Page 1 - Marital Status'
        })
        let anybodyMarried = [PersonalMaritalStatuses.MARRIED,PersonalMaritalStatuses.REMARRIED].includes(mortgage.applicant1.personal.maritalStatus)
        if (!anybodyMarried && mortgage.twoApplicants) {
            anybodyMarried = [PersonalMaritalStatuses.MARRIED,PersonalMaritalStatuses.REMARRIED].includes(mortgage.applicant2.personal.maritalStatus)
        }
        map['Marital Status'] = (!map['Marital Status'] && (config?.maritalStatusMarried || anybodyMarried)) ? {check:{option: 'a'}} : map['Marital Status']

        // marital status - single
        ask.push({
            label: 'Single',
            name: 'maritalStatusSingle',
            type: 'CHECK',
            group: 'Page 1 - Marital Status'
        })
        let anybodySingle = [PersonalMaritalStatuses.SINGLE].includes(mortgage.applicant1.personal.maritalStatus)
        if (!anybodySingle && mortgage.twoApplicants) {
            anybodySingle = [PersonalMaritalStatuses.SINGLE].includes(mortgage.applicant2.personal.maritalStatus)
        }
        map['Marital Status'] = (!map['Marital Status'] && (config?.maritalStatusSingle || anybodySingle)) ? {check:{option: 'b'}} : map['Marital Status']

        // marital status - divorced
        ask.push({
            label: 'Divorced',
            name: 'maritalStatusDivorced',
            type: 'CHECK',
            group: 'Page 1 - Marital Status'
        })
        let anybodyDivorced = [PersonalMaritalStatuses.DIVORCED].includes(mortgage.applicant1.personal.maritalStatus)
        if (!anybodyDivorced && mortgage.twoApplicants) {
            anybodyDivorced = [PersonalMaritalStatuses.DIVORCED].includes(mortgage.applicant2.personal.maritalStatus)
        }
        map['Marital Status'] = (!map['Marital Status'] && (config?.maritalStatusDivorced || anybodyDivorced)) ? {check:{option: 'c'}} : map['Marital Status']

        // marital status - separated
        ask.push({
            label: 'Separated',
            name: 'maritalStatusSeparated',
            type: 'CHECK',
            group: 'Page 1 - Marital Status'
        })
        let anybodySeparated = [PersonalMaritalStatuses.SEPARATED].includes(mortgage.applicant1.personal.maritalStatus)
        if (!anybodySeparated && mortgage.twoApplicants) {
            anybodySeparated = [PersonalMaritalStatuses.SEPARATED].includes(mortgage.applicant2.personal.maritalStatus)
        }
        map['Marital Status'] = (!map['Marital Status'] && (config?.maritalStatusSeparated || anybodySeparated)) ? {check:{option: 'd'}} : map['Marital Status']


        // marital status - other
        ask.push({
            label: 'Other',
            name: 'maritalStatusOther',
            type: 'CHECK',
            group: 'Page 1 - Marital Status'
        })
        let otherDescription = ''
        let alreadyCovered = [PersonalMaritalStatuses.SINGLE,PersonalMaritalStatuses.MARRIED,PersonalMaritalStatuses.REMARRIED, PersonalMaritalStatuses.SEPARATED, PersonalMaritalStatuses.DIVORCED]
        let anybodyOther = !alreadyCovered.includes(mortgage.applicant1.personal.maritalStatus)
        if (anybodyOther){
            otherDescription = mortgage.applicant1.personal.maritalStatus
        }
        if (!anybodyOther && mortgage.twoApplicants) {
            anybodyOther = !alreadyCovered.includes(mortgage.applicant2.personal.maritalStatus)
            if (anybodyOther) {
                otherDescription = mortgage.applicant2.personal.maritalStatus
            }
        }
        map['Marital Status'] = (!map['Marital Status'] && (config?.maritalStatusOther || anybodyOther)) ? {check:{option: 'e'}} : map['Marital Status']

        // marital status other description
        ask.push({
            label: 'Marital Status Other Description',
            name: 'maritalStatusOtherDescription',
            type: 'TEXT',
            group: 'Page 1 - Marital Status'
        })
        map['Marital Status  Details'] = config.hasOwnProperty('maritalStatusOtherDescription') ? {string: config.maritalStatusOtherDescription} : {string: otherDescription}

        // residential status
        let anybodyRenting = mortgage.applicant1.personal.accommodationSituation === PersonalAccommodationSituations.RENTED
        if (!anybodyRenting && mortgage.twoApplicants) {
            anybodyRenting = mortgage.applicant2.personal.accommodationSituation === PersonalAccommodationSituations.RENTED
        }
        map['Residential status:'] = (!map['Residential status:'] &&  anybodyRenting) ? {check:{option: 'a'}} : map['Residential status:']

        let anybodyOwns = mortgage.applicant1.personal.accommodationSituation === PersonalAccommodationSituations.OWNED
        if (!anybodyOwns && mortgage.twoApplicants) {
            anybodyOwns = mortgage.applicant2.personal.accommodationSituation === PersonalAccommodationSituations.OWNED
        }
        map['Residential status:'] = (!map['Residential status:'] &&  anybodyOwns) ? {check:{option: 'b'}} : map['Residential status:']

        let anyoneWithRelatives = mortgage.applicant1.personal.accommodationSituation === PersonalAccommodationSituations.RELATIVES
        if (!anyoneWithRelatives && mortgage.twoApplicants) {
            anyoneWithRelatives = mortgage.applicant2.personal.accommodationSituation === PersonalAccommodationSituations.RELATIVES
        }
        map['Residential status:'] = (!map['Residential status:'] &&  anyoneWithRelatives) ? {check:{option: 'c'}} : map['Residential status:']

        let anyoneOtherText = false
        let anyoneOther = [PersonalAccommodationSituations.OTHER].includes(mortgage.applicant1.personal.accommodationSituation)
        if (anyoneOther){
            anyoneOtherText = mortgage.applicant1.personal.accommodationSituationOther
        }
        if( !anyoneOther && mortgage.twoApplicants){
            anyoneOther = [PersonalAccommodationSituations.OTHER].includes(mortgage.applicant2.personal.accommodationSituation)
            if (anyoneOther){
                anyoneOtherText = mortgage.applicant2.personal.accommodationSituationOther
            }
        }
        map['Residential status:'] = (!map['Residential status:'] &&  anyoneOther) ? {check:{option: 'd'}} : map['Residential status:']

        if (anyoneOtherText){
            map['Residential Status  Details'] = {string: anyoneOtherText}
        }

        // dependants
        map['Number of dependents, ages and childccare arrangements:'] = (()=>{
            let string = ''
            string += strings.children.numberOfDependentsLabel
            string += ': ' + strings.children.totalInWords + '; '
            if (strings.children.numberOfDependentsCombined > 0){
                string += 'Childcare Costs: ' + strings.children.totalChildcareCosts + '\n'
            }
            let existing = mortgage.docContents.find(it => it.document === 'coverLetter' && it.paragraph === `childcareCosts`)
            // add comments
            string += existing && existing.html !== "" ? convertHtmlToPlainText(existing.html) : 'NO COMMENT'
            return {string}
        })()
        // let existing1 = mortgage.docContents.find(it => it.document === 'avantCoverLetter' && it.paragraph === 'dependants')
        //
        // if (existing1) {
        //     map['Text Field 76']  = {string: convertHtmlToPlainText(existing1.html)}
        // }
        // else{
        //     map['Text Field 76'] = {string: 'None'}
        // }

        // outlined proposal
        const strPad = (num, places) => {
            let s = num + " ";
            while (s.length < places) s = s + ".";
            s += " "
            return s;
        }
        function padLine(label, value, targetWidthDots) {
            // Letter width rules
            const getWidth = (ch) => {
                if (ch === 'i') return 1;
                if (ch === 'm' || ch === 'M') return 3; // ensure m/M is 3
                if (ch >= 'A' && ch <= 'Z') return 3;
                if (ch >= 'a' && ch <= 'z') return 2;

                return 2; // numbers, punctuation, spaces (approx)
            };

            // Calculate label width in dots
            let width = 0;
            for (const c of label) width += getWidth(c);

            // How many dots needed to reach target?
            const padDots = Math.max(1, targetWidthDots - width);

            return label + ' '+ '.'.repeat(padDots) + ' ' + value;
        }
        map['Outlined proposal'] = (()=>{
            let string = '';
            string += strings.property.descriptionLabel + ': ' + strings.property.description + ';\n'
            const costs = []
            const funds = []
            const targetWidth = 60
            strings.loan.bof.forEach(row=>{
                if (row[0]!=="" && row[1]!=="") {
                    costs.push(padLine(row[0],  row[1],  targetWidth))
                }
                if (row[2]!=="" && row[3]!=="") {
                    funds.push(padLine(row[2],  row[3],  targetWidth))
                }
            })
            if (costs.length > 0){

                costs.forEach(line=>{
                    string += line + '\n'
                })
            }
            string += '- - - - - - - - - - - - -\n'
            if (funds.length > 0){

                funds.forEach(line=>{
                    string += line + '\n'
                })
            }
            return {string}
        })()


        // let existing2 = mortgage.docContents.find(it => it.document === 'coverLetter' && it.paragraph === 'outlinedProposal')
        // if (existing2) {
        //     map['Text Field 2016'] = {string: convertHtmlToPlainText(existing2.html)}
        // }

        // purchase price
        map['Purchase price/value of property:'] = {string: strings.property.propertyValue}

        // loan amount required
        map['Loan amount required'] = {string: strings.loan.sought}

        // terms required years
        ask.push({
            label: 'Term Required/Years',
            name: 'termRequiredYears',
            type: 'TEXT',
            group: 'Page 1 - Product Details'
        })
        map['Term required years'] = {string: config.hasOwnProperty('termRequiredYears') ? config.termRequiredYears.toString() : (mortgage.activeSubmission.provisionalTerm ||  mortgage.requirement.loanTerm ).toString()}

        //terms required months
        ask.push({
            label: 'Term Required/Months',
            name: 'termRequiredMonths',
            type: 'TEXT',
            group: 'Page 1 - Product Details'
        })
        map['Term required months'] = {string: config.hasOwnProperty('termRequiredMonths') ? config.termRequiredMonths.toString() :  (mortgage.activeSubmission.provisionalTermPlusMonths || 0).toString()}

        // fixed rate 3 years
        ask.push({
            label: 'Fixed Rate/3 Years',
            name: 'fixedRate3Years',
            type: 'CHECK',
            group: 'Page 1 - Product Details'
        })
        map['Fixed rate 3 Year'] = {check: config.hasOwnProperty('fixedRate3Years') ? config.fixedRate3Years : mortgage.activeSubmission.provisionalFixedTerm === 3}

        // fixed rate 4 years
        ask.push({
            label: 'Fixed Rate/4 Years',
            name: 'fixedRate4Years',
            type: 'CHECK',
            group: 'Page 1 - Product Details'
        })
        map['Fixed rate 4 Year'] = {check: config.hasOwnProperty('fixedRate4Years') ? config.fixedRate4Years : mortgage.activeSubmission.provisionalFixedTerm === 4}

        // fixed rate 5 years
        ask.push({
            label: 'Fixed Rate/5 Years',
            name: 'fixedRate5Years',
            type: 'CHECK',
            group: 'Page 1 - Product Details'
        })
        map['Fixed rate 5 Year'] = {check: config.hasOwnProperty('fixedRate5Years') ? config.fixedRate5Years : mortgage.activeSubmission.provisionalFixedTerm === 5}

        // fixed rate 7 years
        ask.push({
            label: 'Fixed Rate/7 Years',
            name: 'fixedRate7Years',
            type: 'CHECK',
            group: 'Page 1 - Product Details'
        })
        map['Fixed rate 7 Year'] = {check: config.hasOwnProperty('fixedRate7Years') ? config.fixedRate7Years : mortgage.activeSubmission.provisionalFixedTerm === 7}

        // fixed rate 10 years
        ask.push({
            label: 'Fixed Rate/10 Years',
            name: 'fixedRate10Years',
            type: 'CHECK',
            group: 'Page 1 - Product Details'
        })
        map['Fixed rate 10 Year'] = {check: config.hasOwnProperty('fixedRate10Years') ? config.fixedRate10Years : mortgage.activeSubmission.provisionalFixedTerm === 10}

        // one mortgage 15 years
        ask.push({
            label: 'One Mortgage/15 Years',
            name: 'oneMortgage15Years',
            type: 'CHECK',
            group: 'Page 1 - Product Details'
        })
        let oneMortgage = false
        if ([15,20,25,30].includes(Number(mortgage.activeSubmission.provisionalFixedTerm) || config?.oneMortgage15Years || config?.oneMortgage20Years || config?.oneMortgage25Years || config?.oneMortgage30Years)){
            oneMortgage = true
        }
        map['One Mortgage'] =  {check : oneMortgage}
        map['Flex Mortgage'] = {check: mortgage.activeSubmission.provisionalFixedTerm === 0}


        // map['Check Box 38'] = {check: config.hasOwnProperty('oneMortgage15Years') ? config.oneMortgage15Years : mortgage.activeSubmission.provisionalFixedTerm === 15}
        //
        // // one mortgage 20 years
        // ask.push({
        //     label: 'One Mortgage/20 Years',
        //     name: 'oneMortgage20Years',
        //     type: 'CHECK',
        //     group: 'Page 1 - Product Details'
        // })
        // map['Check Box 42'] = {check: config.hasOwnProperty('oneMortgage20Years') ? config.oneMortgage20Years : mortgage.activeSubmission.provisionalFixedTerm === 20}
        //
        // // one mortgage 25 years
        // ask.push({
        //     label: 'One Mortgage/25 Years',
        //     name: 'oneMortgage25Years',
        //     type: 'CHECK',
        //     group: 'Page 1 - Product Details'
        // })
        // map['Check Box 37'] = {check: config.hasOwnProperty('oneMortgage25Years') ? config.oneMortgage25Years : mortgage.activeSubmission.provisionalFixedTerm === 25}
        //
        // // one mortgage 30 years
        // ask.push({
        //     label: 'One Mortgage/30 Years',
        //     name: 'oneMortgage30Years',
        //     type: 'CHECK',
        //     group: 'Page 1 - Product Details'
        // })
        // map['Check Box 36'] = {check: config.hasOwnProperty('oneMortgage30Years') ? config.oneMortgage30Years : mortgage.activeSubmission.provisionalFixedTerm === 30}

        // ltv
        map['LTV'] = {string: strings.loan.ltv}

        // property over 100 years old
        ask.push({
            label: 'Is the property over 100 years old: Yes',
            name: 'propertyOver100YearsOldYes',
            type: 'CHECK',
            group: 'Page 1 - Property Details'
        })
        const isOver100 = mortgage.property.propertyAge === '>100' ||  config.propertyOver100YearsOldYes
        map['Is the property over 100 years old:']  = {check: {option:isOver100 ? 'a' : 'b'}}
        // map['Check Box 40'] = {check: config.hasOwnProperty('propertyOver100YearsOldYes') ? config.propertyOver100YearsOldYes : mortgage.property.propertyAge === '>100'}
        // map['Check Box 41'] = {check: config.hasOwnProperty('propertyOver100YearsOldYes') ? !config.propertyOver100YearsOldYes : mortgage.property.propertyAge !== '>100'}


        return {map, ask}
    }
    const page2 = () => {
        let ask=[]
        let map = {}


        // employment
        //app1
        const app1EmpString = `${strings.app1.name} has been employed  (${strings.app1.employment.status}) with ${strings.app1.employment.employerName} as ${strings.app1.employment.occupation} since ${strings.app1.employment.startDate}.\n${strings.app1.employment.variableComments}`

        const app2EmpString = mortgage.twoApplicants ? `${strings.app2.name} has been employed  (${strings.app2.employment.status}) with ${strings.app2.employment.employerName} as ${strings.app2.employment.occupation} since ${strings.app2.employment.startDate}.\n${strings.app2.employment.variableComments}` : ''

        map['Employment details:'] = {string: app1EmpString + (mortgage.twoApplicants ? '\n\n' + app2EmpString : '')}
        // let existing1 = mortgage.docContents.find(it => it.document === 'avantCoverLetter' && it.paragraph === 'employmentDetails')
        // if (existing1) {
        //     map['Text Field 78'] = {string: convertHtmlToPlainText(existing1.html)}
        // }

        //gross income details
        map['Gross income details (Please explain any variable income and provide 3 years evidence)'] = (()=>{
            let string = mortgage.twoApplicants ? mortgage.applicant1.firstName : ''
            string += '\n'
            string += 'Gross Basic Salary: ' + grossBasicMonthlySalary(figures.applicant1.jobs) + ' monthly (' + grossBasicAnnualSalary(figures.applicant1.jobs) + ' annual)\n'
            const data = strings.app1.employment.variableData.rows

            if (data && data.length > 0){
                data.forEach(row=>{
                    string += row.label + ': ' + row.value + '\n'
                })
            }
            if (mortgage.twoApplicants){
                string += '\n'
                string += mortgage.twoApplicants ? mortgage.applicant2.firstName : ''
                string += '\n'
                string += 'Gross Basic Salary: ' + grossBasicMonthlySalary(figures.applicant2.jobs) + ' monthly (' + grossBasicAnnualSalary(figures.applicant2.jobs) + ' annual)\n'
                const data2 = strings.app2.employment.variableData.rows
                if (data2 && data2.length > 0){
                    data2.forEach(row=>{
                        string += row.label + ': ' + row.value + '\n'
                    })
                }
            }
            return {string}
        })()

        // existing debt commitments
        map['Existing debt-commitments: Note: Please ensure you have included credit cards, Overdrafts, other term facilities on the calculator'] = (()=>{

            let string = ''

            const loans1 = mortgage.applicant1.debts.filter(d => d.debtType === DebtTypes.LOAN && !d.isClosed)
            const credits1 = mortgage.applicant1.debts.filter(debt => [
                DebtTypes.CREDITCARD,
                DebtTypes.STORECARD,
            ].includes(debt.debtType) && !debt.isClosed)
            const overdrafts1 = mortgage.applicant1.accounts.filter(acc => acc.hasOverdraft)

            if (loans1.length > 0){
                string += mortgage.applicant1.firstName + ' Loans:\n'
                loans1.forEach(loan=>{
                    string += `- ${loan.lender}: ${toEuroString(loan.monthlyPayment)} monthly${loan.clearedBeforeMortgage ? ' (clearing)':''}\n`
                })
                string += '\n'
            }
            if (credits1.length > 0 || overdrafts1.length > 0){
                string += mortgage.applicant1.firstName + ' Credit Lines:\n'
                credits1.forEach(credit=>{
                    string += '- ' + credit.lender + ' card: ' + toEuroString(credit.creditLimit) + '\n'
                })
                overdrafts1.forEach(od=>{
                    string += '- ' + od.institution + ' overdraft: ' + toEuroString(od.overdraftLimit) + '\n'
                })
                string += '\n'
            }
            if (mortgage.twoApplicants){
                const loans2 = mortgage.applicant2.debts.filter(d => d.debtType === DebtTypes.LOAN && !d.isClosed)


                const credits2 = mortgage.applicant2.debts.filter(debt => [
                    DebtTypes.CREDITCARD,
                    DebtTypes.STORECARD,
                ].includes(debt.debtType) && !debt.isClosed)
                const overdrafts2 = mortgage.applicant2.accounts.filter(acc => acc.hasOverdraft)

                if (loans2.length > 0){
                    string += mortgage.applicant2.firstName + ' Loans:\n'
                    loans2.forEach(loan=>{
                        string += `- ${loan.lender}: ${toEuroString(loan.monthlyPayment)} monthly${loan.clearedBeforeMortgage ? ' (clearing)':''}\n`
                    })
                    string += '\n'
                }
                if (credits2.length > 0 || overdrafts2.length > 0){
                    string += mortgage.applicant2.firstName + ' Credit Lines:\n'
                    credits2.forEach(credit=>{
                        string += '- ' + credit.lender + ' card: ' + toEuroString(credit.creditLimit) + '\n'
                    })
                    overdrafts2.forEach(od=>{
                        string += '- ' + od.institution + ' overdraft: ' + toEuroString(od.overdraftLimit) + '\n'
                    })
                    string += '\n'
                }
            }
            return {string}
        })()

        let numberOfComments = 0
        map['Explanation of any out of course/Large lodgements or withdrawals:'] = (()=>{
            let string = ''
            reviewOfAccounts.forEach(account=>{

                account.rows.forEach(row=>{
                    if (row.comments.length > 0){
                        string += `${row.ownerName} - ${row.institution}\n`
                        row.comments.forEach(comment=>{
                            numberOfComments +=1
                            try{


                                string += `- ${comment.title} (${comment.date}): ${comment.text.join('')}\n`
                            }
                            catch (e) {
                                console.log("Failed Comment", comment)
                                console.log({e})
                            }
                        })
                    }

                })
            })
            return {string}
            // return (
            //     <>
            //         <row>
            //             <cell padding-left="6" padding-right="6" padding-top="3" padding-bottom="3">
            //                 <string>{row.ownerName}</string>
            //             </cell>
            //             <cell>
            //                 <grid vertical-bars="both" horizontal-bars="none" columns={[5, 6, 2, 3, 3, 6]}>
            //                     <row>
            //                         <cell>
            //                             <string>{row.institution}</string>
            //                         </cell>
            //                         <cell>
            //                             <string>{row.startDate} - {row.endDate}</string>
            //                         </cell>
            //                         <cell>
            //                             <string>{`${row.months || '-'}`}</string>
            //                         </cell>
            //                         <cell>
            //                             <string align="right">{row.startBalance}</string>
            //                         </cell>
            //                         <cell>
            //                             <string align="right">{row.endBalance}</string>
            //                         </cell>
            //                         <cell>
            //                             <string>
            //                                 {row.notes}
            //                             </string>
            //                         </cell>
            //                     </row>
            //                 </grid>
            //             </cell>
            //         </row>
            //         {row.comments.length > 0 && (
            //
            //             <row>
            //                 <cell>
            //
            //                 </cell>
            //                 <cell>
            //                     <grid vertical-bars="none" horizontal-bars="none" columns={[3.5, 9, 3, 8.5]}>
            //                         {row.comments.map((comment, i) => {
            //                             return (
            //                                 <row>
            //                                     <cell>
            //                                         <string font-size="7"
            //                                                 color="muted">{i === 0 ? 'Notable Items:' : ''}</string>
            //                                     </cell>
            //                                     <cell>
            //                                         <bullet bullet-size={0.6} bullet-color="green">
            //                                             <string font-size="7" color="muted">{comment.title}</string>
            //                                         </bullet>
            //                                     </cell>
            //                                     <cell>
            //                                         <string font-size="7" color="muted">{comment.date}</string>
            //                                     </cell>
            //                                     <cell>
            //                                         <string font-size="7" color="muted">{comment.text}</string>
            //                                     </cell>
            //                                 </row>
            //                             )
            //                         })}
            //
            //                     </grid>
            //                 </cell>
            //             </row>)}
            //
            //     </>
            // )

        })()

        // let existing2 = mortgage.docContents.find(it => it.document === 'avantCoverLetter' && it.paragraph === 'grossIncomeDetails')
        // if (existing2) {
        //     map['Text Field 180'] = {string: convertHtmlToPlainText(existing2.html)}
        // }

        ask.push({
            label: 'Banking-number of unpaids/referrals',
            name: 'bankingNumberUnpaids',
            type: 'TEXT',
            group: 'Page 2'
        })
        map['Banking-number of unpaids/referrals:'] = {string: config.hasOwnProperty('bankingNumberUnpaids') ? config.bankingNumberUnpaids : '0'}


        let existing3 = mortgage.docContents.find(it => it.document === 'avantCoverLetter' && it.paragraph === 'accountExplanations')
        if (existing3) {
            map['Text Field 189'] = {string: convertHtmlToPlainText(existing3.html)}
        }

        ask.push({
            label: 'Are there any Social Welfare payments?',
            name: 'socialWelfarePaymentsYes',
            type: 'CHECK',
            group: 'Page 2'
        })
        map['Are there any Social Welfare payments?'] = {check: config.socialWelfarePaymentsYes ? {options:'a'} : {options:'b'}}
        // map['Check Box 25'] = {check: config.hasOwnProperty('socialWelfarePaymentsYes') ? config.socialWelfarePaymentsYes : false}
        // map['Check Box 26'] = {check: config.hasOwnProperty('socialWelfarePaymentsYes') ? !config.socialWelfarePaymentsYes : true}

        // let existing4 = mortgage.docContents.find(it => it.document === 'avantCoverLetter' && it.paragraph === 'existingDebtCommitments')
        // if (existing4) {
        //     map['Text Field 182'] = {string: convertHtmlToPlainText(existing4.html)}
        // }

        return {map, ask}
    }
    const page3 = () => {
        let map = {}
        let ask = []

        ask.push({
            label: 'Repayment on proposed facility',
            name: 'repaymentOnProposedFacility',
            type: 'TEXT',
            group: 'Page 3'
        })
        map['Repayment on proposed facility:'] = {string: config.hasOwnProperty('repaymentOnProposedFacility') ? config.repaymentOnProposedFacility : parseInt(output['Expected Payment']).toLocaleString('en-us') }
        map['Where is the repayment ability demonstrated?'] = {string: parseInt(output['Total PRA']).toLocaleString('en-us')}
        // repayment ability
        const repayment = (()=>{
            let string = ''
            if (strings?.pra?.rows?.length){
                strings?.pra?.rows.forEach(row=>{
                    string += row.key + ': ' + row.value + '\n'
                })
            }
            string += strings?.pra?.comment
            return string
        })()
        ask.push({
            label: 'Repayment Ability',
            name: 'repaymentAbility',
            type: 'TEXT',
            group: 'Page 3'
        })
        map['Repayment ability amount evident:'] = {string: config.hasOwnProperty('repaymentAbility') ? config.repaymentAbility : repayment}


        // let existing1 = mortgage.docContents.find(it=>it.document === 'avantCoverLetter' && it.paragraph === 'repaymentCapacity')
        // if (existing1){
        //     map['Text Field 193'] = {string: convertHtmlToPlainText(existing1.html)}
        // }

        // balance of funds required

        ask.push({
            label: 'Balance of funds required',
            name: 'balanceOfFundsRequired',
            type: 'TEXT',
            group: 'Page 3'
        })

        map['Balance of funds required:'] = {string: config.hasOwnProperty('balanceOfFundsRequired') ? config.balanceOfFundsRequired : toEuroString(strings.loan.bofBreakdown.bofNeeded)}


        ask.push({
            label: 'Total Balance of funds on file',
            name: 'totalBalanceOfFundsOnFile',
            type: 'TEXT',
            group: 'Page 3'
        })
        map['Total Balance of funds on file:'] = {string: config.hasOwnProperty('totalBalanceOfFundsOnFile') ? config.totalBalanceOfFundsOnFile : toEuroString(strings.loan.bofBreakdown.euroInBank)}

        ask.push({
            label: 'Source of remaining balance of funds',
            name: 'sourceOfRemainingBalanceOfFunds',
            type: 'TEXT',
            group: 'Page 3'
        })
        map['Source of remaining balance of funds:'] = {string: config.hasOwnProperty('sourceOfRemainingBalanceOfFunds') ? config.sourceOfRemainingBalanceOfFunds : strings.loan.bofBreakdown.fundRows.map(({key,value})=>{
            return `${key}: ${toEuroString(value)}`
            }).join('; ')}

        // security details
        let existing2 = mortgage.docContents.find(it=>it.document === 'coverLetter' && it.paragraph === 'proposedSecurityDetails')

        map['Proposed security details:'] = {string: existing2 ? convertHtmlToPlainText(existing2.html) : 'NO COMMENT'}

        // investment properties
        map['Investment properties (Address, Value, Property type, no of bedrooms, rent etc)'] = (()=>{
            const properties = mortgage.applicant1.properties.filter(it => !it.toBeSold).map(it => ({
                ...it,
                owner: mortgage.applicant1.firstName
            }))
            if (mortgage.twoApplicants) {
                const p2 = mortgage.applicant2.properties.filter(it => !it.toBeSold).map(it => ({
                    ...it,
                    owner: mortgage.applicant2.firstName
                }))
                properties.push(...p2)
            }
            let string = ''
            properties.forEach((property, index)=>{
                string += `${property.address}:\n`
                const parts = []
                parts.push( `Est Value: ${toEuroString( property.estimatedValue)}` )
                if (property.isMortgaged){
                    parts.push( `Mortgage with ${property.lender}: ${toCurrencyString( property.outstanding, property.currency )}` )
                    parts.push( `Monthly Repayment: ${toCurrencyString( property.monthlyRepayments, property.currency)}` )
                    parts.push( `Term left: ${property.remainingTerm} yr` )
                }
                else{
                    parts.push( `Owned Outright` )
                }
                if (property.isRented){
                    parts.push( `Rental Inc: ${toCurrencyString(property.rentPerMonth, property.currency)}` )
                }
                else{
                    parts.push( `Not Rented` )
                }
                parts.push( `Net Value: ${toCurrencyString(property.estimatedValue - property.outstanding, property.currency)}`)
                string += parts.join('; ') + '\n\n'
            })
            return {string}

        })()



        // recommendation
        map['Recommendation/comments:'] = {string: strings.recommendation}


        map['Broker name:'] = {string:'Kevin Coakley'}
        map['Firm:'] = {string:'Truss Mortgages Ltd T/A Sussd Mortgages'}
        map['Contact Detail'] = {string:'01 685-4888 \ kevin@sussd.ie'}

        return {ask, map}
    }
    const sections = [
        page1(),
        page2(),
        page3()
    ]
    console.log({sections})
    return {
        sections
    }
}

function old(mortgage){
    let  map={}

    map['Text Field 74'] = {string: mortgage.applicant1.fullName} // Home loan application app1 and app2 names and age
    map['Check Box 11']
        = {check: mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.applicationType === ApplicationTypes.FIRSTTIME}// FTB
    map['Check Box 12']
        = {check: mortgage.mortgageType === MortgageTypes.PURCHASE && mortgage.applicationType !== ApplicationTypes.FIRSTTIME}
    map['Check Box 13'] = {check: mortgage.mortgageType === MortgageTypes.REFINANCE} // Switcher
    map['Check Box 14'] = {check: false} // Switch with Equity Release
    map['Text Field 1'] = {} // Personal Circumstance
    map['Check Box 15'] = {} // Married
    map['Check Box 16'] = {} // Single
    map['Check Box 17'] = {} // Divorced
    map['Check Box 18'] = {} // Separated
    map['Check Box 19'] = {} // Other
    map['Text Field 75'] = {} // Personal Circumstance Other Description
    map['Check Box 21'] = {} // Residental Status Renting
    map['Check Box 22'] = {} // Residental Status Home Owner
    map['Check Box 23'] = {} // Residental Status Lives with Relatives
    map['Check Box 24'] = {} // Residental Status Other
    map['Text Field 79'] = {} // Residental Status Other Description

    map['Text Field 2016'] = {} // Outlined proposal
    map['Text Field 208'] = {} // Number of dependents, ages and childccare arrangements ????????
    map['Text Field 207'] = {} // Loan amount required
    map['Text Field 209'] = {} // Terms Required/Years
    map['Text Field 2014'] = {} // Term Required/Months
    map['Check Box 30'] = {} // Fixed Rate/3 Years
    map['Check Box 31'] = {} //  Fixed Rate/4 Years
    map['Check Box 32'] = {} //  Fixed Rate/5 Years
    map['Check Box 33'] = {} //  Fixed Rate/7 Years
    map['Check Box 34'] = {} //  Fixed Rate/10 Years
    map['Check Box 38'] = {} // One Mortgage/15 Years
    map['Check Box 42'] = {} // One Mortgage/20 Years
    map['Check Box 37'] = {} // One Mortgage/25 Years
    map['Check Box 36'] = {} // One Mortgage/30 Years
    map['Text Field 2015'] = {} // LTV
    map['Check Box 40'] = {} // Is the property over 100 years old: Yes
    map['Check Box  41'] = {} // Is the property over 100 years old: No
    map['Text Field 78'] = {} // Employment details
    map['Text Field 180'] = {} // Gross income details
    map['Text Field 173'] = {} // Banking-number of unpaids/referrals
    map['Text Field 189'] = {} // Explanation of any out of course/Large lodgements or withdrawals
    map['Check Box 25'] = {} // Are there any Social Welfare payments? Yes
    map['Check Box 26'] = {} // Are there any Social Welfare payments? No
    map['Text Field 182'] = {} // Existing debt-commitments
    map['Text Field 190'] = {} // Repayment on proposed facility
    map['Text Field 192'] = {} // Repayment ability amount evident
    map['Text Field 193'] = {} // Where is the repayment ability demonstrated
    map['Text Field 194'] = {} // Balance of funds required
    map['Text Field 195'] = {} // Total Balance of funds on file
    map['Text Field 196'] = {} // Source of remaining balance of funds
    map['Text Field 205'] = {} // Proposed security details
    map['Text Field 206'] = {} // Investment properties
    map['Text Field 2010'] = {} // Recommendation/comments
    map['Text Field 2011'] = {} // Broker Name
    map['Text Field 2012'] = {} // Firm
    map['Text Field 2013'] = {} // Contact Details
}